import { cloneDeep, merge } from "lodash";
import reduceReducers from "reduce-reducers";

import { ECONTRACT, ECONTRACT_AGREEMENT } from "constants/actionTypes";

import {
  apiModelOfflineCreateReducer,
  apiModelOfflineFetchReducer,
} from "lib/reducers";
import { deserializeEContract } from "lib/serializers/eContracts";

const create = apiModelOfflineCreateReducer(ECONTRACT, {
  deserializer: deserializeEContract,
});

const fetch = apiModelOfflineFetchReducer(ECONTRACT, {
  deserializer: deserializeEContract,
  clearOnRequest: true,
});

/**
 * while similar to apiModelOfflineUpdateReducer,
 * there are a couple of differences that prevent using directly:
 *  - subActionVerb used (VOID / EMAIL vs UPDATE)
 *  - REQUEST payload differences - only id is sent to these endpoints.
 *  - handling of request/success is subtly different
 *    - don't pre-emptively show any changes to the local instance
 *      until the server has responded with the updated payload
 */
function eContractVoidReducers(state, action) {
  switch (action.type) {
    case ECONTRACT.EMAIL.REQUEST:
    case ECONTRACT.VOID.REQUEST: {
      const { id } = action.payload;
      const data: EContract = deserializeEContract(
        action.payload,
        state.byId[id] || {},
      );
      return {
        ...state,
        byId: {
          ...state.byId,
          [id]: merge(cloneDeep(state.byId[id]), {
            ...data,
            syncing: true,
          }),
        },
      };
    }

    case ECONTRACT.EMAIL.SUCCESS:
    case ECONTRACT.VOID.SUCCESS:
    case ECONTRACT.SHARE_CONFIRM.SUCCESS: {
      const { payload } = action;
      const data: EContract = deserializeEContract(payload);

      return {
        ...state,
        byId: {
          ...state.byId,
          [data.id]: data,
        },
      };
    }

    default:
      return state;
  }
}

// When an eContract is generated from an agreement, the server returns the new
// eContract. Add it directly to the store so the card updates immediately.
function eContractAgreementGenerateContractReducer(state, action) {
  switch (action.type) {
    case ECONTRACT_AGREEMENT.GENERATE_CONTRACT.SUCCESS: {
      const econtract: EContract = deserializeEContract(action.payload);
      return {
        ...state,
        byId: {
          ...state.byId,
          [econtract.id]: econtract,
        },
      };
    }
    default:
      return state;
  }
}

const EContracts = reduceReducers(
  create,
  fetch,
  eContractVoidReducers,
  eContractAgreementGenerateContractReducer,
);

export default EContracts;
